/** Thin blue progress line. The only loading state Kova uses. */
export function LoadingLine({ active, className = '' }: { active: boolean; className?: string }) {
  if (!active) return null;
  return (
    <div className={`h-[3px] w-full overflow-hidden rounded bg-blueTint ${className}`} role="progressbar" aria-label="Loading">
      <div className="h-full w-full origin-left rounded bg-blue animate-fillLine" />
    </div>
  );
}
